import { addMessages } from '@hana/i18n';

// Chuỗi dùng chung của các màn Nhân sự (Ezy › hr). Mã nghiệp vụ, tên riêng, dữ liệu không dịch.
addMessages('vi', {
  'hr.s.newVer': 'Phiên bản mới',
  'hr.s.approveUse': 'Duyệt dùng',
  'hr.s.noContractMatch': 'Không có hợp đồng khớp bộ lọc.',
  'hr.s.noWrite': 'Chưa mở ghi ở bản này',
  'hr.s.retry': 'Thử lại',
  'hr.s.meeSub': 'Chấm công · đơn · phiếu lương của tôi',
  'hr.s.openMee': 'Mở HANA Mee ↗',
  'hr.s.absentToday': 'Tôi vắng hôm nay',
  'hr.s.leaveReq': 'Đơn nghỉ',
  'hr.s.expSoon': 'Sắp hết hạn · ≤ 30 ngày',
  'hr.s.renew': 'Gia hạn',
  'hr.s.tplPending': 'Mẫu chờ duyệt',
  'hr.s.issueContract': 'Phát hành hợp đồng',
  'hr.s.load5': 'Nạp 5 mẫu chuẩn',
  'hr.s.needAction': 'Cần xử lý',
  'hr.s.contractLife': 'Vòng đời hợp đồng',
  'hr.s.legalCheck': 'Kiểm pháp lý khi phát hành',
  'hr.s.backDecisions': 'Về sổ quyết định',
  'hr.s.current': 'Hiện tại',
  'hr.s.rejectReason': 'Lý do từ chối',
  'hr.s.cancel': 'Huỷ',
  'hr.s.sendReject': 'Gửi từ chối',
  'hr.s.viewPrint': 'Xem bản in',
  'hr.s.assignSeat': 'Giao ghế ở Cơ cấu & ghế (điền sẵn số QĐ) ›',
  'hr.s.noTodo': 'Không còn việc nào.',
  'hr.s.absentTodayShort': 'Vắng hôm nay',
  'hr.s.openFull': 'Mở hồ sơ đầy đủ trên máy tính ↗',
  'hr.s.reject': 'Từ chối',
  'hr.s.kpiMine': 'Việc KPI chờ tôi',
  'hr.s.bySeat': 'theo ghế [SALE-MGR] DAVID',
  'hr.s.mgrAdjust': 'Điều chỉnh quản lý cho phòng SALE',
  'hr.s.optionalNote': 'không bắt buộc · có ghi chú',
  'hr.s.zeroOf4': '0 / 4 người',
  'hr.s.list': 'Danh sách',
  'hr.s.orgTree': 'Cây tổ chức',
  'hr.s.jdDesc': 'Mô tả công việc theo chức danh × bậc',
  'hr.s.syncSeats': 'Đồng bộ ghế từ hồ sơ',
  'hr.s.title': 'Chức danh',
  'hr.s.grade': 'Bậc (trong khung của chức danh)',
  'hr.s.jdVer': 'Phiên bản v1 · bản gốc',
  'hr.s.discard': 'Bỏ thay đổi',
  'hr.s.saveJd': 'Lưu JD · phiên bản mới',
  'hr.s.edit': 'Sửa',
  'hr.s.del': 'Xoá',
  'hr.s.inFrame': 'Vừa khung',
  'hr.s.clearFilter': 'Xoá lọc',
  'hr.s.newStaff': 'Nhân sự mới',
  'hr.s.days': 'ngày',
});
addMessages('en', {
  'hr.s.newVer': 'New version',
  'hr.s.approveUse': 'Approve for use',
  'hr.s.noContractMatch': 'No contracts match the filter.',
  'hr.s.noWrite': 'Writing is not enabled in this build',
  'hr.s.retry': 'Retry',
  'hr.s.meeSub': 'My attendance · requests · payslips',
  'hr.s.openMee': 'Open HANA Mee ↗',
  'hr.s.absentToday': 'I am absent today',
  'hr.s.leaveReq': 'Leave request',
  'hr.s.expSoon': 'Expiring soon · ≤ 30 days',
  'hr.s.renew': 'Renew',
  'hr.s.tplPending': 'Templates pending approval',
  'hr.s.issueContract': 'Issue contract',
  'hr.s.load5': 'Load 5 standard templates',
  'hr.s.needAction': 'Needs action',
  'hr.s.contractLife': 'Contract lifecycle',
  'hr.s.legalCheck': 'Legal check on issue',
  'hr.s.backDecisions': 'Back to decision register',
  'hr.s.current': 'Current',
  'hr.s.rejectReason': 'Reason for rejection',
  'hr.s.cancel': 'Cancel',
  'hr.s.sendReject': 'Send rejection',
  'hr.s.viewPrint': 'View print',
  'hr.s.assignSeat': 'Assign seat in Structure & seats (decision no. prefilled) ›',
  'hr.s.noTodo': 'No tasks left.',
  'hr.s.absentTodayShort': 'Absent today',
  'hr.s.openFull': 'Open full profile on desktop ↗',
  'hr.s.reject': 'Reject',
  'hr.s.kpiMine': 'KPI tasks waiting for me',
  'hr.s.bySeat': 'by seat [SALE-MGR] DAVID',
  'hr.s.mgrAdjust': 'Manager adjustment for SALE department',
  'hr.s.optionalNote': 'optional · with note',
  'hr.s.zeroOf4': '0 / 4 people',
  'hr.s.list': 'List',
  'hr.s.orgTree': 'Org tree',
  'hr.s.jdDesc': 'Job description by title × grade',
  'hr.s.syncSeats': 'Sync seats from profiles',
  'hr.s.title': 'Job title',
  'hr.s.grade': 'Grade (within the title frame)',
  'hr.s.jdVer': 'Version v1 · original',
  'hr.s.discard': 'Discard changes',
  'hr.s.saveJd': 'Save JD · new version',
  'hr.s.edit': 'Edit',
  'hr.s.del': 'Delete',
  'hr.s.inFrame': 'Within frame',
  'hr.s.clearFilter': 'Clear filters',
  'hr.s.newStaff': 'New staff',
  'hr.s.days': 'days',
});
